// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ZnVt","content":"styles_content__1M3e2"};